import axios from 'axios'
import { Message } from 'element-ui';
import router from '../router'
axios.defaults.baseURL = process.env.API_ROOT;
axios.defaults.timeout = 1000 * 60 //请求超时时间
axios.defaults.headers['Content-Type'] = 'application/json' //请求头部类型
// axios.defaults.headers.AUTHORIZTION_FLAG = ''; //权限标识

var CancelToken = axios.CancelToken;
var source = CancelToken.source();

/* axios.interceptors.request.use(function (config) {
    console.log(config);
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }); */

// 响应拦截器
axios.interceptors.response.use(
    response => {
       
        if (false === response.data.success) {
            // Message({
            //     type: "warning",
            //     message: response.data.error
            // })
            alert(response.data.error)
        }
        if(1001 == response.data.code){
            router.push('/login')
     
            source.cancel('Operation canceled by the user.');
            
        }
        return response;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 400:
                    if (error.response && error.response.data && error.response.data.message) {
                        /*Notice.error(
                            {
                                title: error.response.data.message,
                                duration: 5,
                                closable: true
                            }
                        )*/
                    }
                    break;
                case 401:
                    // 401 清除token信息
                    
                    break;
                case 403:
                    /*Notice.error(
                        {
                            title: '没有操作权限',
                            duration: 5,
                            closable: true
                        }
                    )*/
                    break;
                case 500:
                    /*Notice.error(
                        {
                            title: '服务器出了小问题',
                            duration: 5,
                            closable: true
                        }
                    )*/
                    break;

            }
        }
        return Promise.reject(error)
    });
    export default axios;


// WEBPACK FOOTER //
// ./src/api/config.js